import React from "react";
import { inject, observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";

import {
  Button,
  Container,
  CssBaseline,
  TextField,
  CircularProgress
} from "@material-ui/core";

import logo from "../img/logo-full.png";

const styles = theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    height: "2rem"
  },
  logo: {
    height: "4rem",
    width: "auto"
  }
});

class Login extends React.Component {
  login(e) {
    e.preventDefault();
    this.props.login(
      e.target.username.value,
      e.target.password.value,
      success => {
        if (success) {
          this.props.notificationStore.show("success", "Logged in!");
        } else {
          this.props.notificationStore.show(
            "error",
            "Incorrect username or password!"
          );
        }
      }
    );
  }

  render() {
    const classes = this.props.classes;

    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <img
            src={logo}
            alt="Strella Biotechnology"
            className={classes.logo}
          />
          <form
            onSubmit={e => this.login(e)}
            className={classes.form}
            noValidate
          >
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
              autoFocus
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              disabled={this.props.loggingIn}
            >
              {this.props.loggingIn ? (
                <CircularProgress size={16} />
              ) : (
                "Sign In"
              )}
            </Button>
          </form>
        </div>
      </Container>
    );
  }
}

export default withStyles(styles)(
  inject(stores => ({
    login: stores.rootStore.authStore.login,
    loggingIn: stores.rootStore.authStore.loggingIn,
    notificationStore: stores.rootStore.notificationStore
  }))(observer(Login))
);
